import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "../../ui/chip.js";
export function Suggestions({ suggestions, spent, onChoose, }) {
    if (suggestions === undefined || suggestions.length === 0)
        return null;
    return (_jsx("div", { className: "wp-chips", "data-suggestions": "", "data-spent": spent ? "" : undefined, children: suggestions.map((suggestion, i) => (_jsx(Chip, { variant: "suggestion", compact: true, "data-suggestion": suggestion.id, disabled: spent, onClick: () => {
                onChoose(suggestion);
            }, children: suggestion.label }, `${String(i)}:${suggestion.id}`))) }));
}
//# sourceMappingURL=suggestions.js.map